export default "__VITE_ASSET__BrH2EPbi__"